import React from 'react'
import styles from './AudioTabContent.module.scss'
import {AudioSlider} from './AudioSlider'
import {T} from '@colonist/ui'
import {useGameUserSettingsSetVolume} from '../../../hooks/useGameUserSettingsVolume'
import {useGameStore} from '../../../store/GameStoreContext'

export const AudioTabContent = () => {
    const volume = useGameStore((state) => state.gameUserSettings.volume)
    const setVolume = useGameUserSettingsSetVolume()

    return <div className={styles.container}>
        <div className={styles.heading}><T id='strings:game.settings.audioTab.volume'/></div>
        <div className={styles.volumeContainer}>
            <div className={styles.volumeText}>{(volume * 100).toFixed(0)}</div>
            <div className={styles.volumeSlider}>
                <AudioSlider onChange={setVolume} value={volume}/>
            </div>
        </div>
    </div>
}
